// Import our custom CSS
import "../styles/index.scss";
import { Collapse } from "bootstrap"; // Specific module

// BS5 Collapse (Só funciona se tiver usando algum boostrap)
Array.from(document.querySelectorAll('[data-bs-toggle="collapse"]')).forEach(
  (itemNode) => new Collapse(itemNode)
);

// jQuery
import jQuery from "jquery";

// Slick Slider
import "slick-carousel";

// Unidades
import "./unidades.js";

// Formulário
import "./formulario.js";

jQuery(document).ready(function () {
  setTimeout(() => {
    jQuery("body").show();
  }, 200);

  let urlAtual = window.location.href;

  if (!urlAtual.includes("obrigado.html")) {
    //reset form quando entrar na página princiapl
    jQuery("#formulario-inscricao")[0].reset();

    //Mostra a barra fixa quando tiver scroll na página
    window.onscroll = changePos;

    // Scroll para o formulário
    jQuery(".cta-inscricao").click(function (event) {
      event.preventDefault();
      jQuery("html,body").animate(
        { scrollTop: jQuery("#calculadora").offset().top - 30 },
        "slow",
        function () {
          jQuery("#mediaForm")
            .find("input[type=text]")
            .filter(":visible:first")
            .focus();
        }
      );
    });
  }

  //script para página de obrigado
  if (urlAtual.includes("obrigado.html")) {
    //Recupera o e-mail da sessiona storage
    let data = sessionStorage.getItem("userEmail");
    data ? jQuery("#email-cadastrado").text(data) : "";

    jQuery(".btn-copy").on("click", function () {
      navigator.clipboard.writeText(window.location.origin);
      jQuery(".btn-copy").text("Copiado");
      jQuery(".btn-copy").attr("disabled", "disabled");

      setTimeout(() => {
        jQuery(".btn-copy").text("Copiar link");
        jQuery(".btn-copy").removeAttr("disabled");
      }, 5000);
    });
  }

  function changePos() {
    var barraFixa = document.getElementById("barra-fixa");
    if (window.pageYOffset > 680) {
      barraFixa.classList.add("visivel");
    } else {
      barraFixa.classList.remove("visivel");
    }
  }
  
});

